// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoUserOutlinedSvg from "@fishx/icons-svg/es/asn/PtoUserOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoUserOutlined = function PtoUserOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoUserOutlinedSvg
  }));
};

PtoUserOutlined.displayName = 'PtoUserOutlined';
export default React.forwardRef(PtoUserOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoUserOutlined.js
// module id = 3934
// module chunks = 0